import secureClient from 'lib/secure-client';
import exclusiveUrl from 'shared_js/helpers/urlHelper/exclusiveUrl';
import isMwebUrl from 'shared_js/helpers/urlHelper/isMwebUrl';

/**
 * Retrieve Toggles Status
 * https://blueprint.bukalapak.io/exclusive/t/neo~v2~neo~toggle~post~exclusive~neo~toggles
 * Retrieve toggles status by array of id and platform.
 */
function retrieveTogglesStatus(ids, platform) {
  const defaultPlatform = isMwebUrl() ? 'bl_mobile_web' : 'bl_web';
  const options = {
    data: {
      id: ids,
      platform: platform || defaultPlatform,
    },
  };

  return this.post(`${exclusiveUrl}/neo/toggles`, 'user', options);
}

/**
 * Retrieve neo admin config by id
 * @param {String} id - 'some-neo-id'
 */
function retrieveNeoAdminConfig(id) {
  return this.get(`${exclusiveUrl}/neo/admin/configs`, 'user', {
    params: {
      keyword: id,
    },
  });
}

/**
 * Create new or update neo config
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.id
 * @param {[String]} [payload.username_admin] - usernames of granted admins to edit value
 */
function createNeoConfig(payload) {
  return this.put(`${exclusiveUrl}/neo/admin/configs`, 'user', {
    data: payload,
  });
}

/**
 * Search configs by ids
 * https://blueprint.bukalapak.io/exclusive/t/neo~v2~neo~config~post~exclusive~neo~configs
 * @param {Array} ids
 */
function retrieveNeoConfig(ids) {
  return this.post('/_exclusive/neo/configs', 'user', {
    data: {
      id: ids,
    },
  });
}

const exclusiveNeoApi = secureClient({
  retrieveTogglesStatus,
  retrieveNeoAdminConfig,
  createNeoConfig,
  retrieveNeoConfig,
});

export default exclusiveNeoApi;
